/**
 * Returns true if the given CSS colour value is considered transparent/absent.
 *
 * @param {string} colour
 * @returns {boolean}
 */
const isTransparent = colour =>
  !colour || colour === 'rgba(0, 0, 0, 0)' || colour === 'transparent';

/**
 * Walks the subtree of `element` depth-first (last child first) and returns
 * the computed background-color of the deepest last descendant that has a
 * non-transparent background. Returns null if none is found.
 *
 * @param {HTMLElement} element
 * @returns {string|null}
 */
const resolveBackground = element => {
  const bg = getComputedStyle(element).backgroundColor;

  if (!isTransparent(bg)) {
    return bg;
  }

  // Walk children in reverse so we check the visually last child first
  const children = Array.from(element.children);

  for (let i = children.length - 1; i >= 0; i--) {
    const result = resolveBackground(children[i]);

    if (result) {
      return result;
    }
  }

  return null;
};

export const getPreviousSiblingBackground = element => {
  const parent = element.parentElement;

  if (!parent) {
    return null;
  }

  const children = Array.from(parent.children);

  let lastSibling = null;

  for (let i = children.length - 1; i >= 0; i--) {
    if (children[i] !== element) {
      lastSibling = children[i];
      break;
    }
  }

  if (!lastSibling) {
    return null;
  }

  return resolveBackground(lastSibling);
};
